import React from 'react';
import PropTypes from 'prop-types';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsLinkLabel } from './ps-link-label/PsLinkLabel';
import { PsRoutes } from '../../../shared/routing/Routes';

export const WorkerLabel = (
    {
        worker,
    },
) => {
    const [to, setTo] = React.useState(undefined);

    React.useEffect(() => {
        if ( worker ) {
            const origin = worker.origin();
            const routeParams = {};
            const route = origin.isFromMyContractors()
                ? PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL
                : PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL;

            if ( origin.hasCompany() ) {
                routeParams.outsourceId = origin.companyId();
            }

            if ( origin.hasWorker() ) {
                routeParams.workerId = origin.workerId();
            }

            const nextTo = RouterUtils.generateRoute(route, routeParams);
            const isWrong = nextTo.includes('undefined');

            if ( !isWrong ) {
                setTo(nextTo);
            }
        }
    }, [worker]);

    if ( !worker ) {
        return null;
    }

    const workerCompleteName = worker.completeName();

    return (
        <PsLinkLabel
            to={to}
            label={workerCompleteName}
        />
    );
};

WorkerLabel.propTypes = {
    worker: PropTypes.object,
};

WorkerLabel.defaultProps = {
    worker: null,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/shared/components/WorkerLabel.jsx